// extracted by mini-css-extract-plugin
export default {"root":"button_root__XXNqS","link":"button_link__PM5Hm"};